import { EyeIcon, EyeOffIcon } from 'lucide-react'
import React, { useState } from 'react'

import { renderFormattedSSN } from 'components/members/utils'
import { Badge, IconButton, TextLink } from 'slab'
import { capitalize, getFormattedDate, supportLinks } from 'utils'
import type {
  MembersCoveredParticipant,
} from 'utils/web_api.schemas'

interface CoveredDependentDetailsProps {
  coveredParticipant: MembersCoveredParticipant;
}

const CoveredDependentDetails: React.FC<CoveredDependentDetailsProps> = ({
  coveredParticipant,
}) => {
  const [showFullSSN, setShowFullSSN] = useState(false)

  const toggleSSNVisibility = () => {
    setShowFullSSN(!showFullSSN)
  }

  return (
    <div className='border-t py-4' key={coveredParticipant.id}>
      <div className='flex gap-2 mb-4 items-center'>
        {coveredParticipant.relationship === 'self' ? 'You' : capitalize(coveredParticipant.relationship)}
        {coveredParticipant.relationship === 'self' && <Badge type='info'>Primary member</Badge>}
      </div>
      <div className='grid grid-cols-2 gap-4'>
        <div>
          <div className='body text-gray-500'>Full name</div>
          <div className='body'>{coveredParticipant.given_name} {coveredParticipant.family_name}</div>
        </div>
        <div>
          <div className='body text-gray-500'>Date of birth</div>
          <div className='body sensitive'>{getFormattedDate(coveredParticipant.dob + 'T00:00:00')}</div>
        </div>
        <div>
          <div className='body text-gray-500'>SSN</div>
          <div className='flex items-center gap-2 body sensitive'>
            {coveredParticipant.ssn && (
              <div className='body sensitive font-mono'>
                {renderFormattedSSN(coveredParticipant.ssn, showFullSSN)}
              </div>
            )}
            {coveredParticipant.ssn && (
              <IconButton
                icon={showFullSSN ? EyeOffIcon : EyeIcon}
                label={showFullSSN ? 'Hide SSN' : 'Show SSN'}
                onClick={toggleSSNVisibility}
              />
            )}
          </div>
        </div>
        <div>
          <div className='body text-gray-500'>Member ID</div>
          <div className='body sensitive'>{
            coveredParticipant.carrier_member_id || (
              <TextLink
                data-testid='member-id-link'
                href={supportLinks.memberId}
                target='_blank'
              >
                Contact your carrier
              </TextLink>
            )
          }
          </div>
        </div>
      </div>
    </div>
  )
}

export default CoveredDependentDetails
